// No need to import fetch if using Node.js 18+

import { XMLParser } from 'fast-xml-parser';

export async function makeLoginRequest(urlBase, usr, psw) {

	const url = urlBase + "/login.xml";

	const postData = `usr::=${usr}&psw::=${psw}`;
    let idHttpSessionId = "";

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
            },
            body: postData,
        });

        if (!response.ok) {
            let errorBody = "Could not read error body.";
            try {
                errorBody = await response.text();
            } catch (e) {}
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}. Body: ${errorBody}`);
        }

        const responseBody = await response.text();

        const setCookieHeaders = [];
        for (const [key, value] of response.headers.entries()) {
            if (key.toLowerCase() === 'set-cookie') {
                setCookieHeaders.push(value);
            }
        }

        if (setCookieHeaders && setCookieHeaders.length > 0) {
            for (const cookieHeader of setCookieHeaders) {
                const parts = cookieHeader.split(';');
                const mainCookiePart = parts[0].trim();
                if (mainCookiePart.startsWith('IDHTTPSESSIONID=')) {
                    idHttpSessionId = mainCookiePart.split('=')[1];
                    break;
                }
            }
        }

    } catch (error) {
        console.error("Error making POST request:");
        console.error(error.message);
        if (error.cause) {
            console.error("Cause:", error.cause);
        }
    }
	
	return idHttpSessionId;
}

function notRoomYN(addr1) {
	
	var notRoomArray = ["561", "811", "880", "806", "807", "808", "809", "966", "481", "491", "480", "490"];

	var i;
	var addr2;
	
	for(i=0; i<notRoomArray.length; i++) {
		addr2 = notRoomArray[i];
		if (addr1 === addr2) {
			return true;
		}
	}
	
	return false;
}

function swapAddr(addr) {

	if (addr === "432") {
		return "431";
	}
	
	if (addr === "433") {
		return "432";
	}
	
	if (addr === "434") {
		return "433";
	}
	
	if (addr === "435") {
		return "434";
	}
	
	if (addr === "436") {
		return "435";
	}
	
	if (addr === "437") {
		return "436";
	}
	
	if (addr === "438") {
		return "437";
	}
	
	if (addr === "439") {
		return "438";
	}
	
	if (addr === "440") {
		return "439";
	}
	
	if (addr === "441") {
		return "440";
	}
	
	if (addr === "481") {
		return "441";
	}
	
	return addr;
}

function parseOneItem(itemObj1) {

	var itemObj2;
	var addr1 = itemObj1.addr;
	var type = itemObj1.type;
	var statusi = itemObj1.statusi;
	var deponed = itemObj1.deponed;
	var ch;
	
	var addr2 = swapAddr(addr1);
	
	if (addr2 === "347") {
		//console.log("statusi:");
		//console.log(statusi);
		//console.log("");
	}
	
	if (notRoomYN(addr2)) {
		return null;
	}

	if ((type !== "1") && (type !== "2") && (type !== "3")) {
		return null;
	}
	
	// odustao od ovoga
	//ch = statusi.charAt(3);
	
	var roomNumber = addr2;
	if (type === "3") {
		if (addr2 === "455") {
			roomNumber = "405-1";
		}
		if (addr2 === "456") {
			roomNumber = "406-1";
		}
		if (addr2 === "551") {
			roomNumber = "521-1";
		}
		if (addr2 === "555") {
			roomNumber = "525-1";
		}
	}

	var roomStatus = "vacant";
	ch = statusi.charAt(28);
	if (ch === "1") {
		roomStatus = "sos1";
	}
	if (ch === "2") {
		roomStatus = "sos2";
	}
	if (ch === "3") {
		roomStatus = "unauthrized";
	}
	if (ch === "4") {
		roomStatus = "rented_guest_in_room";
	}
	if (ch === "5") {
		roomStatus = "staff";
	}
	if (ch === "6") {
		roomStatus = "rented_guest_not_in_room";
	}
	
	var setTemperature = "";
	var roomTemperature = "";
	ch = statusi.charAt(12).charCodeAt(0)-65;
	setTemperature = ch;
	ch = statusi.charAt(14).charCodeAt(0)-65;
	roomTemperature = ch;
	
	var ch = statusi.charAt(13);
	var pointStr = ch;
	
	var cardPresentYN = 0;
	if (deponed !== "Odlagač prazan") {
		cardPresentYN = 1;
	}
	
	var cardName = "";
	if (cardPresentYN === 1) {
		if (deponed !== "n/a") {
			cardName = deponed;
		}
	}
	
	ch = statusi.charAt(11);
	var staffStr = ch;

	ch = statusi.charAt(1);
	var doorStr = ch;
	
	ch = statusi.charAt(2);
	var windowStr = ch;

	ch = statusi.charAt(5);
	var acStr = ch;

	ch = statusi.charAt(12);
	var ignoreCardStr = ch;
	
	itemObj2 = itemObj1;
	itemObj2.roomNumber = roomNumber;
	itemObj2.roomStatus = roomStatus;
	itemObj2.setTemperature = setTemperature;
	itemObj2.roomTemperature = roomTemperature;
	itemObj2.pointStr = pointStr;
	itemObj2.cardPresentYN = cardPresentYN;
	itemObj2.cardName = cardName;
	itemObj2.doorStr = doorStr;
	itemObj2.windowStr = windowStr;
	itemObj2.staffStr = staffStr;
	itemObj2.acStr = acStr;
	itemObj2.ignoreCardStr = ignoreCardStr;
	
	return itemObj2;
}

function parseStanjeXml(xmlString) {
	
	if (xmlString === "") {
		return null;
	}

	const parser = new XMLParser({
		ignoreAttributes: false,           // Important to keep attributes like addr, type, etc.
		attributeNamePrefix: "",           // Remove default @ prefix
	});

	var jsonObj = parser.parse(xmlString);
	var xmlObj = jsonObj.XML;
	var hotelObj = xmlObj.HOTEL;
	var sobaArray = hotelObj.SOBA;
	var i;
	var itemObj1;
	var itemObj2;
	var stateArray = [];

	for(i=0; i<sobaArray.length; i++) {
		itemObj1 = sobaArray[i];
		itemObj2 = parseOneItem(itemObj1);
		if (itemObj2 !== null) {
			//console.log(itemObj2);
			stateArray.push(itemObj2);
		}
	}

	return stateArray;
}

export async function getStanjeXml(urlBase, idHttpSessionId) {

	var url = urlBase + "/stanje.xml";
	
	var cookieString = "IDHTTPSESSIONID=" + idHttpSessionId;
	var xmlString = "";

    try {

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
				"Cookie": cookieString,
            },
        });

        if (!response.ok) {
			var errorBody = "";
            try {
                errorBody = await response.text();
            } catch (e) {}
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}. Body: ${errorBody}`);
        }

        xmlString = await response.text();

    } catch (error) {
        console.error(error.message);
        if (error.cause) {
            console.error("Cause:", error.cause);
        }
    }
	
	var stateArray = parseStanjeXml(xmlString);
	return stateArray;
}

// in the future maybe eliminate some addr --- leave only rooms
export function combineArrays(stateArray1, stateArray2) {

	var i;
	var itemObj;
	var stateArray = [];
	
	for(i=0; i<stateArray1.length; i++) {
		itemObj = stateArray1[i];
		stateArray.push(itemObj);
	}
	
	for(i=0; i<stateArray2.length; i++) {
		itemObj = stateArray2[i];
		stateArray.push(itemObj);
	}
	
	return stateArray;
}

